/**
 * User-timing marks for the Home tiles ("pilot:<name>"), measured from navigation start.
 * Read them in the console with performance.getEntriesByType('mark'). Free, and unlike resource
 * timing they are not capped at 250 entries (dev mode fills that buffer with module files).
 */
const done = new Set();

export function markOnce(name) {
  if (done.has(name) || typeof performance === 'undefined' || !performance.mark) return;
  done.add(name);
  try { performance.mark(`pilot:${name}`); } catch { /* ignore */ }
}
